export default {
  buttons: {
    more_payment_methods: 'Altri metodi di pagamento',
  },
  toasts: {
    processing: "Elaborazione dati di pagamento. Ti aggiorneremo al termine dell'elaborazione.",
    failed: 'Impossibile elaborare i dati di pagamento. Prova un altro metodo di pagamento.',
    failed_to_load: 'Impossibile caricare il modulo di pagamento. Ricarica la pagina e riprova.',
    failed_to_save_payment_method: 'Impossibile salvare il metodo di pagamento',
    failed_to_create_checkout_session: 'Qualcosa è andato storto, riprova',
  },
};
